import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.fill.js";
import styled from 'styled-components';
import { pxToRem, pxToEm, getPropNamesFromPropDefinition } from 'utils/ui';
import marginProps, { marginPropsDef } from 'styles/styleProps/marginProps';
var iconSize = 18;
function getScaleFromFlipAxis(axis) {
  switch (axis) {
    case 'x':
      return ' scaleX(-1)';
    case 'y':
      return ' scaleY(-1)';
    default:
      return '';
  }
}
var marginPropNames = getPropNamesFromPropDefinition(marginPropsDef);
function shouldForwardProp(prop) {
  return !['scale', 'vAlign', 'dimmed', 'rotate', 'flip', 'disablePointerEvents'].concat(_toConsumableArray(marginPropNames)).includes(prop);
}
var BaseSvg = styled.svg.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "BaseSvg",
  componentId: "sc-sfxc1j-0"
})(["display:inline-block;vertical-align:middle;flex:0 0 auto;width:1em;height:1em;fill:", ";", " font-size:", ";", " ", " ", " ", ""], function (p) {
  return p.fill;
}, marginProps, function (p) {
  return p.scale && p.scale !== 0 ? pxToEm(iconSize * (p.scale || 1)) : pxToRem(iconSize);
}, function (p) {
  return p.vAlign && "\n\t\t\t/* Use to align icons with surrounding body text */\n\t\t\tposition: relative;\n\t\t\ttop: -0.12em;\n\t\t";
}, function (p) {
  return p.dimmed && "\n\t\t\topacity: ".concat(p.theme.textDimStrength, ";\n\t\t");
}, function (p) {
  return (p.rotate || p.flip) && "\n\t\t\ttransform: rotate(".concat(p.rotate || 0, "deg)").concat(p.flip ? getScaleFromFlipAxis(p.flip) : '', ";\n\n\t\ttransition: transform 0.2s cubic-bezier(0.3, 0.8, 0.46, 1.25);\n\t");
}, function (p) {
  return p.disablePointerEvents && "\n\t\t\tpointer-events: none;\n\t\t";
});
export default BaseSvg;